import { Row as RowBase } from '@hud/web-components/Layout/Layout';
import styled from 'styled-components';
import { LineChart } from '@hud/web-components/Charts/LineChart/LineChart';
import { Container as BaseContainer } from '@hud/web-components/Container/Container';

export const Row = styled(RowBase)`
  max-height: 510px;
`;

export const FunctionsLineChart = styled(LineChart)`
  transform: translateY(-40px);
`;

export const FunctionBehaviorChartContainer = styled(BaseContainer)`
  flex: 1;
  overflow: hidden;
`;

export const FunctionBehaviorContainer = styled.div`
  flex: 1;
`;
